(function () {
  function enhance() {
    var imgs = document.querySelectorAll('.rte img:not([data-vs-enhanced])');
    imgs.forEach(function (img) {
      img.setAttribute('data-vs-enhanced', '1');
      img.decoding = 'async';

      var wrap = document.createElement('span');
      wrap.className = 'vs-img-skeleton';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);

      function reveal() {
        img.classList.add('vs-img-loaded');
        wrap.classList.add('vs-img-loaded');
      }

      if (img.complete && img.naturalWidth > 0) {
        reveal();
      } else {
        img.addEventListener('load', reveal, { once: true });
        img.addEventListener('error', reveal, { once: true });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
